module.exports = __webpack_public_path__ + "static/media/story-24.0dbc4fa7.jpg";